import { useQuery } from "@apollo/client";

import { GET_PRODUCT_CATEGORY_QUERY, GET_PRODUCT_QUERY } from "./documents";
import {
  TGetProductCategoryData,
  TGetProductCategoryVariables,
  TGetProductCategoryOptions,
  TGetProductData,
  TGetProductVariables,
} from "./types";

export function useGetProductCategoryQuery(
  options?: TGetProductCategoryOptions
) {
  const query = useQuery<TGetProductCategoryData, TGetProductCategoryVariables>(
    GET_PRODUCT_CATEGORY_QUERY,
    options
  );

  return query;
}

export function useGetProductQuery(options?: TGetProductCategoryOptions) {
  const query = useQuery<TGetProductData, TGetProductVariables>(
    GET_PRODUCT_QUERY,
    options
  );

  return query;
}
